module.exports = __webpack_public_path__ + "img/suojelija_2024.ef683b57.png";